<app-card-content [border]="false" icon="pi pi-key" title="Catálogo de Roles" subtitle="Roles do Keycloak por módulo, funcionalidade e ação">
    <div card-header class="flex gap-2 items-center">
        <p-iconfield iconPosition="left">
            <p-inputicon styleClass="pi pi-search" />
            <input pInputText type="text" [ngModel]="filtro()" (ngModelChange)="filtro.set($event)" placeholder="Buscar role..." />
        </p-iconfield>
        <p-button label="Nova role" icon="pi pi-plus" (onClick)="abrirNova()"></p-button>
    </div>

    @if (grupos().length === 0) {
        <div class="p-4 text-center text-muted-color">Nenhuma role encontrada.</div>
    } @else {
        <div class="flex flex-wrap gap-2 text-xs items-center mb-3">
            <span class="text-muted-color">Legenda:</span>
            <span class="acao-chip tipo-C">Criar</span>
            <span class="acao-chip tipo-R">Visualizar</span>
            <span class="acao-chip tipo-U">Editar</span>
            <span class="acao-chip tipo-D">Excluir</span>
            <span class="acao-chip tipo-E">Específica</span>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <app-card-content [border]="true" [headerColor]="true" icon="pi pi-folder" title="Módulos">
                <div class="flex flex-col gap-1">
                    @for (mod of grupos(); track mod.modulo) {
                        <div class="kanban-item flex justify-between items-center" [class.is-sel]="mod.modulo === moduloAtual()?.modulo" (click)="selecionarModulo(mod)">
                            <span>{{ mod.moduloLabel }}</span>
                            <span class="text-xs text-muted-color">{{ mod.total }}</span>
                        </div>
                    }
                </div>
            </app-card-content>

            <app-card-content [border]="true" [headerColor]="true" icon="pi pi-list" title="Funcionalidades">
                @if (moduloAtual(); as mod) {
                    <div class="flex flex-col gap-1">
                        @for (f of mod.funcionalidades; track f.funcionalidade) {
                            <div class="kanban-item" [class.is-sel]="f.funcionalidade === funcAtual()?.funcionalidade" (click)="selecionarFunc(f)">{{ f.funcionalidadeLabel }}</div>
                        }
                    </div>
                }
            </app-card-content>

            <app-card-content [border]="true" [headerColor]="true" icon="pi pi-bolt" title="Ações">
                @if (funcAtual(); as f) {
                    <p-table [value]="f.todas" styleClass="p-datatable-sm">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Ação</th>
                                <th>Role</th>
                                <th>Descrição</th>
                                <th style="width: 6rem"></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-a>
                            <tr>
                                <td>
                                    <span class="acao-chip tipo-{{ a.crud || 'E' }}">{{ a.acaoLabel }}</span>
                                </td>
                                <td class="text-sm font-mono">{{ a.role }}</td>
                                <td>{{ a.descricao }}</td>
                                <td class="whitespace-nowrap">
                                    <p-button icon="pi pi-pencil" ariaLabel="Editar descrição" [text]="true" [rounded]="true" severity="secondary" pTooltip="Editar descrição" (onClick)="abrirEdicao(a.role, a.descricao)"></p-button>
                                    <p-button
                                        icon="pi pi-trash"
                                        ariaLabel="Exclusão desabilitada (operação sensível)"
                                        [text]="true"
                                        [rounded]="true"
                                        severity="danger"
                                        [disabled]="true"
                                        pTooltip="Exclusão desabilitada (operação sensível)"
                                        (onClick)="confirmarExcluir(a.role)"
                                    ></p-button>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                }
            </app-card-content>
        </div>
    }
</app-card-content>

<p-confirmdialog></p-confirmdialog>
<app-role-detalhe [showDialog]="modalNova()" (showDialogChange)="modalNova.set($event)" [edicao]="roleEmEdicao()" [modulosSugeridos]="modulosExistentes()" [funcionalidadesSugeridas]="funcsExistentes()" (salvou)="onRoleSalva()"></app-role-detalhe>
